import React, { useEffect, useState } from 'react';
import Persyaratan from '../../../modules/Persyaratan';
import View from '../../../modules/View';
import apiService from 'apiService';

const mapValuesToPostParams = async (values, idPendaftaran) => {
  const toBase64 = async (file) => {
    if (await file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
  };
  const properties = [];
  const newValues = Object.keys(values).map((key, i) => {
    properties[ i ] = {
      ref_persyaratan_id: values[ key ].id,
      trx_pend_perusahaan_id: idPendaftaran,
    };
    return toBase64(values[ key ].file);
  });

  const postParams = await Promise.all(newValues).then((results) =>
    properties.map((propertie, i) => ({ ...propertie, upload: results[ i ] }))
  );

  return postParams;
};

const RumahMakanPersyaratan = ({
  existingPersyaratan,
  nextStep,
  setData,
  onAfterPost,
  typeId,
  isShow,
  idPendaftaran,
  ...rest
}) => {
  const [ persyaratan, setPersyaratan ] = useState('');
  const getPersyaratan = async (refId) => {
    try {
      const responses = await apiService.get(
        `/department/persyaratan/find/${ refId }`
      );
      if (responses) {
        setPersyaratan(responses.data);
        setData((prevState) => ({
          ...prevState,
          dataPersyaratan: responses.data,
        }));
      }
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (!existingPersyaratan) getPersyaratan(typeId);
    else setPersyaratan(existingPersyaratan);
  }, []);

  if (!isShow) return '';

  return (
    <>
      <View
        data={ existingPersyaratan || persyaratan || [] }
        idPendaftaran={ idPendaftaran }
        handleSubmit={ nextStep }
      />
    </>
  );
};

export default RumahMakanPersyaratan;
